import type { HtmlEmbedHint } from '../../contracts';

interface ShouldOpenSourceInViewerOptions {
  url?: string;
  embed?: HtmlEmbedHint;
  isMobile: boolean;
  /**
   * Port 7. `isAuthenticatedSourceUrl` reads nine `NEXT_PUBLIC_*` values through
   * `getDomains()`, which ruling 52 holds app-side, so it is required rather
   * than defaulted — a default would silently route authenticated Heidi links
   * out to a browser tab.
   */
  isAuthenticatedUrl: (url: string, embed?: HtmlEmbedHint) => boolean;
  /**
   * Some source surfaces (citation badges, reference rows) already use the
   * in-app viewer for ordinary desktop URLs. Partner CTAs only use the viewer
   * for authenticated Heidi links or legacy BE-flagged embeddable HTML.
   */
  useViewerForDesktopUrls?: boolean;
}

export function shouldOpenSourceInViewer({
  url,
  embed,
  isMobile,
  isAuthenticatedUrl,
  useViewerForDesktopUrls = true,
}: ShouldOpenSourceInViewerOptions): boolean {
  if (!url) return false;
  if (isAuthenticatedUrl(url, embed)) return true;
  if (embed?.mode === 'html' && !isMobile) return true;
  return useViewerForDesktopUrls && !isMobile;
}
